import * as React from 'react';
import { Svg } from '../svg';
import { BoxProps } from '../box';

export const ExternalIcon = (props: BoxProps) => (
  <Svg width="8" height="9" viewBox="0 0 8 9" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.30849 0H7.04391H7.99975H7.99981V6.6919H7.04391V1.66447L0.707141 8.00185L0 7.29477L6.33818 0.955986H1.30849V0Z"
      fill="#677282"
    />
  </Svg>
);
